import clsx from 'clsx';

//types
import type { AlbumCardGridLayoutType, AlbumCardMedia } from '@/lib/albums/types';

import { getCardPostIconClasses, LiPostIcons } from '@/lib/albums/albumCardIconType';
//libs
import { getCardGridStyles } from '@/lib/albums/getCardGridStyles';
import { LINKEDIN } from '@/lib/socialProfile';

//components
import Icon from '@/components/base/Icon';

function MediaGridLinkedin({
    medias,
    gridLayout
}: {
    medias: AlbumCardMedia[];
    gridLayout: AlbumCardGridLayoutType;
}) {
    const maxMedias = gridLayout === 'card' ? 4 : 3;
    const renderedMedias = medias.length > maxMedias ? medias.slice(0, maxMedias) : medias;
    return (
        <>
            {renderedMedias.map((media, index) => (
                <span
                    key={index}
                    data-testid={`grid-linkedin-${media.type}`}
                    className={clsx(
                        getCardGridStyles({
                            index: index + 1,
                            size: renderedMedias?.length,
                            network: LINKEDIN,
                            gridLayout
                        }),
                        { 'row-span-8': medias.length === 3 && index === 0 } // add style in here since this class isn't in tailwind stylesheets
                    )}>
                    <span
                        className={clsx(
                            'flex h-full w-full items-center justify-center',
                            getCardPostIconClasses(media.type as keyof typeof LiPostIcons)
                        )}>
                        <Icon
                            icon={LiPostIcons[media.type]}
                            data-testid={`icon-linkedin-${LiPostIcons[media.type]}`}
                        />
                    </span>
                </span>
            ))}
        </>
    );
}

export default MediaGridLinkedin;
